import { doAttention } from '@/attention';
export function pulse(el, duration = undefined, options = {}) {
    return doAttention(el, 'pulse', duration, options);
}
//# sourceMappingURL=pulse.js.map